import '../styles/style.css';

import * as React from 'react';

import {
    GlancePair,
    Partner,
    Region,
    StudioAppConfig,
} from 'glance-datatypes';
import { GridList, GridTile } from 'material-ui/GridList';
import { Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle } from 'material-ui/Toolbar';
import { green300, green500, grey500, grey800, orange300, orange500, red300, red500 } from 'material-ui/styles/colors';
import { regionFilters, stateFiltersInternal } from '../Utils';

import Configuration from '../Configuration';
import Dialog from 'material-ui/Dialog';
import DropDownMenu from 'material-ui/DropDownMenu';
import EmptyMessage from './common/EmptyMessage';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import Glance from './Glance';
import JerseyRestApiService from '../JerseyRestApiService';
import Loader from './common/Loader';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import Snackbar from 'material-ui/Snackbar';
import TextFeild from 'material-ui/TextField';
import Utils from '../Utils';
import { connect } from 'react-redux';

const approveIcon = <FontIcon className='material-icons'>check</FontIcon>;
const rejectIcon = <FontIcon className='material-icons'>remove_circle_outline</FontIcon>;
let timer;

const styles = {
    footer: {
        position: 'fixed',
        bottom: '0px',
        paddingBottom: '10px',
        paddingTop: '10px',
        zIndex: 10,
        backgroundColor: grey800,
        width: '90%',
        maxWidth: '1400px',
        display: 'inline-flex',
        justifyContent: 'center',
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, visibility 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    } as React.CSSProperties,
    footerButton: {
        maxWidth: '232px',
        flex: '1 1 0%',
        marginLeft: '10px',
        marginRight: '10px',
    } as React.CSSProperties,
    deleteButton: {
        color: red500,
        background: red300,
    } as React.CSSProperties,
    disabledButton: {
        backgroundColor: grey500,
    } as React.CSSProperties,
    loaderStyle: {
        textAlign: 'center',
    } as React.CSSProperties,
    approveButton: {
        color: green500,
        background: green300,
    } as React.CSSProperties,
    rejectButton: {
        color: orange500,
        background: orange300,
    } as React.CSSProperties,
};

enum TypeFilter {
    ALL, WALLPAPER, STORY, SPONSORED,
}

enum StateFilter {
    PENDING, APPROVED, REJECTED,
}

enum Action {
    APPROVE, REJECT,
}

interface Props {
    params: any;
    history?: any;
    conf?: Configuration;
    studioAppConfig?: StudioAppConfig;
}

interface State {
    partnerFilter?: Partner;
    partnerAutoApprove?: boolean;
    regionFilter?: Region;
    regionFilters?: Region[];
    filter: string;
    expiryFilter: boolean;
    stateFilter?: StateFilter;
    selectedGlances?: Map<string, boolean>;
    loadMessage?: string;
    showLoader?: boolean;
    possibleActions?: Action[];
    actionClicked?: Action;
    openConfirmDialog: boolean;
    openSnackbar: boolean;
    snackbarMessage: string;
    glancePairs?: GlancePair[];
    perPage: number;
    selectedPage: number;
    searchTerm: string;
    rejectReason: String;
    categoryIds: String[];
    isWebpeek: boolean;
    storyType: string[];
}

class InternalApprovalGlances extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            partnerFilter: null,
            regionFilters: [1,2,3,4,5,6,7,8,9,10,27,29],
            regionFilter: null,
            filter: 'games',
            stateFilter: StateFilter.PENDING,
            expiryFilter: false,
            openConfirmDialog: false,
            openSnackbar: false,
            snackbarMessage: '',
            loadMessage: 'Select a region',
            perPage: 200,
            glancePairs: [],
            selectedPage: 1,
            searchTerm: '',
            selectedGlances: new Map<string, boolean>(),
            possibleActions: [],
            rejectReason: '',
            categoryIds: ['#games'],
            isWebpeek: false,
            storyType: undefined,
        };
    }

    componentWillMount() {
        // TODO: now studioAppConfig will always have a default value. this check needs to be changed
        if (!this.props.studioAppConfig) {
            this.props.history.push('/login');
            window.location.reload();
        }
        if (this.props.params) {
            const { region } = this.props.params;
            if (region) {
                this.setRegion(parseInt(region));
            }
        }
    }

    componentDidMount() {
        const possibleActions = this.getPossibleActions();
        this.setState({
            ...this.state,
            possibleActions,
        });
    }

    pushFilterUrl = (regionFilter: Region) => {

        this.props.history.push('/' + this.props.params.role + '/internalApproval'
                + (regionFilter ? ('/' + regionFilter + '/' + Utils.getReadableRegionName(regionFilter)) : ''),
        );
    }

    setRegion = (region: Region) => {
            this.setState({
                ...this.state,
                regionFilter: region,
                loadMessage: 'Loading live glances in ' + Utils.getReadableRegionName(region) + ' ..',
                showLoader: true,
            }, () => {
                this.fetchGlances(true);
            });
    }

    fetchGlances = (resetPage) => {
        if (this.state.regionFilter !== null){
            const { perPage, regionFilter, selectedPage, expiryFilter, stateFilter, searchTerm,
                storyType, categoryIds, isWebpeek } = this.state;

            const state = stateFiltersInternal[stateFilter];

            const region = regionFilters[regionFilter];

            // const offset = resetPage ? 0 : (selectedPage - 1) * perPage;

            const payload = {
                limit: perPage,
                // offset,
                isExpiry: expiryFilter,
                state,
                region,
                search: searchTerm,
                storyType,
                categoryIds,
                isWebpeek,
            };
            this.setState({
                ...this.state,
                showLoader: true,
                selectedPage: resetPage ? 1 : selectedPage,
            });
            JerseyRestApiService.getInternalGlances(payload, (response: any) => {
                const data = response;
                Utils.parseGlancePairs(data);
                const newStateMap: Map<string, boolean> = new Map<string, boolean>();
                this.setState({
                    ...this.state,
                    glancePairs: data,
                    showLoader: false,
                    snackbarMessage: 'Glances loaded',
                    openSnackbar: true,
                    loadMessage: null,
                });

            }, (error: any) => {
                console.log(error);
                this.setState({
                    ...this.state,
                    snackbarMessage: 'Loading failed. Try refresh or Contact Glance Support.',
                    openSnackbar: true,
                    loadMessage: 'Loading failed. Try refresh or Contact Glance Support.',
                    showLoader: false,
                });
            });
        } else {
            this.setState({
                ...this.state,
                snackbarMessage: 'Please Select a Region',
                openSnackbar: true,
                loadMessage: 'Select a region',
                showLoader: false,
            });
        }
    }

    handleRegionFilterChange = (event: any, index: number, value: Region) => {
        this.pushFilterUrl(value);
        this.setRegion(value);
    }

    handleTypeFilterChange = (event: any, index: number, value: string) => {
        let categoryIds:string[], storyType:string[], isWebpeek: boolean = false;
        switch (index) {
            case 0:
                categoryIds = ['#games'];
                break;
            case 1:
                categoryIds = ['#live_game_shows'];
                break;
            case 2:
                categoryIds = ['#live_game_streams'];
                break;
            case 3:
                storyType = ['GLANCETV'];
                break;
            case 4:
                isWebpeek = true;
                break;

        }
        this.setState({
            ...this.state,
            filter: value,
            categoryIds,
            storyType,
            isWebpeek,
        }, () => this.fetchGlances(true));
    }

    handleExpiryFilterChange = (event: any, index: number, value: boolean) => {
        this.setState({
            ...this.state,
            expiryFilter: value,
        }, () => this.fetchGlances(true));
    }

    handleStateFilterChange = (event: any, index: number, value: StateFilter) => {
        this.pushFilterUrl(this.state.regionFilter);
        const possibleActions = this.getPossibleActions(value);

        this.setState({
            ...this.state,
            stateFilter: value,
            possibleActions,
        }, () => {  this.fetchGlances(true);});
    }

    getPossibleActions = (stateFilter = this.state.stateFilter) => {
        let possibleActions: Action[];
        switch (stateFilter) {
            case StateFilter.APPROVED:
                break;
            case StateFilter.PENDING:
                possibleActions = [Action.APPROVE, Action.REJECT];
                break;
            case StateFilter.REJECTED:
            default:
                possibleActions = null;
        }
        this.setState({
            ...this.state,
            possibleActions,
        });
        return possibleActions;
    }

    onSelectGlance = (element: any, selected: boolean) => {
        const newMap = new Map<string, boolean>(this.state.selectedGlances);
        if (selected) {
            newMap.set(element.data.glanceId, true);
        } else {
            newMap.delete(element.data.glanceId);
        }

        this.setState({
            ...this.state,
            selectedGlances: newMap,
        });
    }

    handleAction = (action: Action) => {
        this.setState({
            ...this.state,
            actionClicked: action,
            openConfirmDialog: true,
        });
    }

    handleActionConfirm = (action: Action) => {
        const selectedIds: string[] = [];
        this.state.selectedGlances.forEach((value: boolean, glanceId: string) => {
            selectedIds.push(glanceId);
        });
        this.setState({
            ...this.state,
            snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...',
            openSnackbar: true,
        });
        switch (action) {
                case Action.APPROVE:
                    JerseyRestApiService.approveInternalGlances(regionFilters[this.state.regionFilter], selectedIds, (success) => {
                    this.handleActionComplete(action, success);
                });
                break;
            default:
                break;
        }
    }

    handleActionRejectConfirm = (action: Action, rejectReason: String) => {
        const selectedIds: string[] = [];
        this.state.selectedGlances.forEach((value: boolean, glanceId: string) => {
            selectedIds.push(glanceId);
        });
        this.setState({
            ...this.state,
            snackbarMessage: 'Starting to ' + Action[action] + ' Glances ...',
            openSnackbar: true,
        });
        JerseyRestApiService.rejectInternalGlances(regionFilters[this.state.regionFilter], rejectReason, selectedIds, (success) => {
            this.handleActionComplete(action, success);
        });
    }

    handleActionComplete = (action: Action, success: boolean) => {
        if (success) {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Glance ' + Action[action] + ' done. Updating view...',
                openConfirmDialog: false,
                selectedGlances: new Map<string, boolean>(),
            });
            this.fetchGlances(true);
        } else {
            this.setState({
                ...this.state,
                openSnackbar: true,
                snackbarMessage: 'Unable to ' + Action[action] + ' glances. Contact Glance Support.',
                openConfirmDialog: false,
            });
        }
    }

    closeConfirmDialog = () => {
        this.setState({
            ...this.state,
            openConfirmDialog: false,
        });
    }

    closeSnackbar = () => {
        this.setState({
            ...this.state,
            openSnackbar: false,
        });
    }

    searchHandler = (event: any) => {

        if (timer) {
            clearTimeout(timer);
        }
        this.setState({
            ...this.state,
            searchTerm: event.target.value,
        });
        timer = setTimeout(() => {
               this.fetchGlances(true);
        }, 800);

    }
    searchButton = () => {
        this.fetchGlances(true);
    }

    onPageChange = (page) => {
        this.setState({
            ...this.state,
            selectedPage: page,
            selectedGlances: new Map<string, boolean>(),
        }, () => {
            this.fetchGlances(false);
        });
    }

    rejectReasonHandler = (event: any) => {
        this.setState({
            ...this.state,
            rejectReason: event.target.value,
        });
    }

    render() {
        const actions = [];
        const { perPage, glancePairs, showLoader } = this.state;
        let paginationElement = [];
        // if (glancePairs.length > 0) {
        //     paginationElement.push(
        //         <Pagination
        //             pageSize={perPage}
        //             onPageChange={this.onPageChange}
        //             disabled={showLoader}
        //             disableNextBtn= {glancePairs.length < perPage}
        //         />
        //     );
        // }
        actions.push(
            <FlatButton label='Cancel' primary={true} style={{width: '100%'}}
                onClick={this.closeConfirmDialog} />,
        );
        actions.push(
            <FlatButton label={ ((this.state.actionClicked == Action.REJECT) ? ''
                : 'Yes, ' ) + Action[this.state.actionClicked]} primary={true}
                style={{width: '100%'}}
                onClick={() => (this.state.actionClicked == Action.REJECT)
                    ? this.handleActionRejectConfirm(this.state.actionClicked, this.state.rejectReason)
                    : this.handleActionConfirm(this.state.actionClicked)} />,
        );
        return (
            <div>
                {
                        <Toolbar style={{ marginTop: '2%' }}>
                            <ToolbarGroup firstChild={true}>
                                <ToolbarTitle text='Filters' style={{ marginLeft: '24px' }} />
                                <ToolbarSeparator />

                                <DropDownMenu value={this.state.regionFilter}
                                    onChange={this.handleRegionFilterChange}>
                                    <MenuItem value={null} primaryText={'Select Region'} key='empty'></MenuItem>
                                    {
                                        this.state.regionFilters.map((item, index) => {
                                            return (
                                                <MenuItem value={item} primaryText={Utils.getReadableRegionName(item)} key={index} />
                                            );
                                        })
                                    }
                                </DropDownMenu>
                                {
                                        <DropDownMenu value={this.state.stateFilter}
                                            onChange={this.handleStateFilterChange}>
                                            <MenuItem value={StateFilter.PENDING} primaryText='Pending Approval' />
                                            <MenuItem value={StateFilter.APPROVED} primaryText='Approved Glances' />
                                            <MenuItem value={StateFilter.REJECTED} primaryText='Rejected Glances' />
                                        </DropDownMenu>
                                }
                                <DropDownMenu value={this.state.filter}
                                    onChange={this.handleTypeFilterChange}>
                                    <MenuItem value={'games'} primaryText='Games' />
                                    <MenuItem value={'live_game_shows'} primaryText='Live Game Shows' />
                                    <MenuItem value={'live_game_streams'} primaryText='Live Game Streams' />
                                    <MenuItem value={'glance_tv'} primaryText='Glance Tv' />
                                    <MenuItem value={'isWebpeek'} primaryText='WebPeek' />
                                </DropDownMenu>
                                <DropDownMenu value={this.state.expiryFilter}
                                    onChange={this.handleExpiryFilterChange}>
                                    <MenuItem value={false} primaryText='Active Glances' />
                                    <MenuItem value={true} primaryText='Expired Glances' />
                                </DropDownMenu>
                                <div className='wrapInternal'>
                                    <div className='searchInternal'>
                                        <input type='text'
                                            value={this.state.searchTerm}
                                            onChange={this.searchHandler}
                                            placeholder='Search...'
                                            className='searchTerm'
                                        />
                                        <button type='submit' className='searchButton' onClick={this.searchButton}>
                                            <i>
                                                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'>
                                                    <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
                                                </svg>
                                            </i>
                                        </button>
                                    </div>
                                </div>
                            </ToolbarGroup>
                        </Toolbar>
                }
                {this.state.regionFilter ? (
                    <Loader show={showLoader} message={this.state.loadMessage}>
                    {
                        this.state.glancePairs && this.state.glancePairs.length > 0 ?
                        <div>
                            <GridList
                            cols={4}
                            padding={15}
                                style={{ width: '100%', margin: '0 auto', marginTop: '2%' }}
                                cellHeight='auto'>
                                {
                                    this.state.glancePairs.map((pair: any, glanceIndex) => {
                                        return (<GridTile key={glanceIndex}
                                            containerElement={
                                                <Glance glance={pair} selected={this.state.selectedGlances.get(pair.data.glanceId)}
                                                    region={this.state.regionFilter} partner={this.state.partnerFilter}
                                                    onSelect={(selected: boolean) => this.onSelectGlance(pair, selected)}
                                                />
                                            }>
                                        </GridTile>);
                                    })
                                }
                            </GridList>
                        </div>
                        : <EmptyMessage message='No glances for selected filters'></EmptyMessage>

                    }
                    </Loader>

                        ) : <EmptyMessage message={this.state.loadMessage}></EmptyMessage>
                }
                {
                    paginationElement
                }
                {
                    this.state.possibleActions && this.state.selectedGlances && this.state.selectedGlances.size > 0 ?
                        <div style={styles.footer}>
                            {this.state.partnerAutoApprove ? '' :
                            <RaisedButton
                                label={'Approve Selected (' + this.state.selectedGlances.size + ')'}
                                icon={approveIcon}
                                primary
                                buttonStyle={this.state.possibleActions.indexOf(Action.APPROVE) < 0 ? styles.disabledButton : styles.approveButton}
                                style={styles.footerButton}
                                onClick={() => this.handleAction(Action.APPROVE)}
                                disabled={this.state.possibleActions.indexOf(Action.APPROVE) < 0}
                            />
                            }
                            {this.state.partnerAutoApprove ? '' :
                            <RaisedButton
                                label={'Reject Selected (' + this.state.selectedGlances.size + ')'}
                                icon={rejectIcon}
                                primary
                                buttonStyle={this.state.possibleActions.indexOf(Action.REJECT) < 0 ? styles.disabledButton : styles.rejectButton}
                                style={styles.footerButton}
                                onClick={() => this.handleAction(Action.REJECT)}
                                disabled={this.state.possibleActions.indexOf(Action.APPROVE) < 0}
                            />
                            }
                        </div> : ''
                }
                {this.state.actionClicked == Action.REJECT
                ?
                    <Dialog modal={false}
                        open={this.state.openConfirmDialog}
                        onRequestClose={this.closeConfirmDialog}

                        actions={actions}
                    >
                        Please enter reason for rejecting Glances
                        <span className=''> : </span>
                        <TextFeild
                            type = 'text'
                            className = ''
                            onChange = {this.rejectReasonHandler}
                        />
                    </Dialog>
                :
                    <Dialog modal={false}
                        open={this.state.openConfirmDialog}
                        onRequestClose={this.closeConfirmDialog}

                        actions={actions}
                    >
                        Please confirm that you want to {Action[this.state.actionClicked]} these glances.
                    </Dialog>
                }
                <Snackbar open={this.state.openSnackbar} message={this.state.snackbarMessage} onRequestClose={this.closeSnackbar} autoHideDuration={2000} />
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};

export default connect(mapStateToProps)(InternalApprovalGlances);



// WEBPACK FOOTER //
// ./src/components/InternalApprovalGlances.tsx